import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <footer>
        <p>
          <a
            href="https://github.com/Shobhit51/"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>{" "}
          🚀
        </p>
      </footer>
    </div>
  );
}
